import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M14.1423 9.5H15.5544C16.3448 9.5 16.7356 10.58 16.1761 11.21L12.0996 15.8C11.7532 16.19 11.1937 16.19 10.8473 15.8L6.7708 11.21C6.21128 10.58 6.61094 9.5 7.40137 9.5H8.8135V4.5C8.8135 3.95 9.21316 3.5 9.70163 3.5H13.2541C13.7426 3.5 14.1423 3.95 14.1423 4.5V9.5ZM6.14911 20.5C5.66064 20.5 5.26099 20.05 5.26099 19.5C5.26099 18.95 5.66064 18.5 6.14911 18.5H16.8066C17.2951 18.5 17.6948 18.95 17.6948 19.5C17.6948 20.05 17.2951 20.5 16.8066 20.5H6.14911Z";

export default function UploadIcon(props: IconProps) {
  return (
    <SVGIcon path={path} {...props} fillRule="evenodd" clipRule="evenodd" />
  );
}
